import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'msisdnFormat'})
export class MsisdnFormat implements PipeTransform {
  transform(msisdn: string): string {
    if (!msisdn) {
      return msisdn;
    }

    msisdn = msisdn.replace(/((\+48)|(\+\s48))?(\s)*/ig, '').replace(/\D/g, '');

    if (msisdn.length === 9 || msisdn.length === 11) {
      let formattedNumber = '';

      if (msisdn.length === 9) {
        formattedNumber = msisdn.match(/.{1,3}/g)?.join(' ') || '';
      } else if (msisdn.length === 11) {
        formattedNumber = msisdn.slice(2).match(/.{1,3}/g)?.join(' ') || '';
      }

      return '+48 ' + formattedNumber;
    }

    return msisdn;
  }
}
